import {gql} from "@irati/utils/gql"

const fragment = gql`
  fragment paymentMethods on PaymentMethods {
    groups {
      groupType
      name
      types
    }
    oneClickPaymentMethods {
      brands
      details {
        details {
          items {
            id
            name
          }
          key
          optional
          type
          value
        }
        itemSearchUrl
        items {
          id
          name
        }
        key
        optional
        type
        value
      }
      group {
        name
        paymentMethodData
        type
      }
      name
      paymentMethodData
      recurringDetailReference
      storedDetails {
        bank {
          bankAccountNumber
          bankCity
          bankLocationId
          bankName
          bic
          countryCode
          iban
          ownerName
          taxId
        }
        card {
          cvc
          expiryMonth
          expiryYear
          holderName
          issueNumber
          number
          startMonth
          startYear
        }
        emailAddress
      }
      supportsRecurring
      type
    }
    paymentMethods {
      brands
      details {
        details {
          items {
            id
            name
          }
          key
          optional
          type
          value
        }
        itemSearchUrl
        items {
          id
          name
        }
        key
        optional
        type
        value
      }
      group {
        name
        paymentMethodData
        type
      }
      name
      paymentMethodData
      supportsRecurring
      type
    }
    storedPaymentMethods {
      brand
      expiryMonth
      expiryYear
      holderName
      id
      lastFour
      name
      shopperEmail
      supportedShopperInteractions
      type
    }
  }
`

export const toString = fragment.loc.source.body

export default fragment
